import { Box } from 'braid-design-system';

import * as styles from './DropdownBackdrop.css';

interface DropdownBackdropProps {
  onClick: () => void;
}

export const DropdownBackdrop = ({ onClick }: DropdownBackdropProps) => (
  <Box
    className={styles.dropdownBackdrop}
    zIndex="dropdownBackdrop"
    onClick={(event) => {
      event.stopPropagation();
      event.preventDefault();
      onClick();
    }}
  />
);
